module.exports = __webpack_public_path__ + "static/img/gerenad.e9aa30b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gerenad.jpg
// module id = Twep
// module chunks = 171